import { get, post } from "../common/query";

export const GET_BIRTHDAYINFO = params => get("/user/bpage", params);
export const GET_BIRTHCARD = params => post("/coupon/recBcoupon", params);

